import { render, staticRenderFns } from "./AppConfigMsgBox.vue?vue&type=template&id=69091985&"
import script from "./AppConfigMsgBox.vue?vue&type=script&lang=js&"
export * from "./AppConfigMsgBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69091985')) {
      api.createRecord('69091985', component.options)
    } else {
      api.reload('69091985', component.options)
    }
    module.hot.accept("./AppConfigMsgBox.vue?vue&type=template&id=69091985&", function () {
      api.rerender('69091985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/modal/AppConfigMsgBox.vue"
export default component.exports